module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_03.cf781729.jpg";